// Мета-теги страниц на языке страницы.
//
// ЗАЧЕМ. В __root дефолтные title, description, og и twitter были написаны
// по-азербайджански и по-английски сразу, и любой маршрут, не перекрывший
// их сам, отдавал их как есть: у /coaches и /start twitter-теги стояли на
// чужом языке, у /en/coaches twitter:title — азербайджанский (замер
// 05.10.2026). Теперь __root выбирает дефолты по языку адреса, а маршруты
// со своими текстами отдают полный набор через socialMeta.
//
// Сторож — scripts/verify-page-meta.mts.

export type MetaLang = "ru" | "az" | "en";

export const OG_LOCALE: Record<MetaLang, string> = { ru: "ru_RU", az: "az_AZ", en: "en_US" };

/**
 * Язык страницы для мета-тегов — тем же порядком, что <html lang> в
 * RootShell: ?lang, суффикс _az/_en, префикс /az или /en, иначе ru.
 */
export function metaLang(pathname: string, searchLang?: unknown): MetaLang {
  if (searchLang === "ru" || searchLang === "az" || searchLang === "en") return searchLang;
  if (pathname.endsWith("_az")) return "az";
  if (pathname.endsWith("_en")) return "en";
  if (pathname === "/az" || pathname.startsWith("/az/")) return "az";
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  return "ru";
}

export const DEFAULT_META: Record<MetaLang, { title: string; description: string }> = {
  ru: {
    title: "Yolutap — платформа карьерной навигации",
    description: "Yolutap — платформа профориентации и развития для детей и молодёжи 10–22 лет.",
  },
  az: {
    title: "Yolutap — karyera naviqasiyası platforması",
    description: "Yolutap — 10–22 yaşlı uşaq və gənclər üçün peşəyönümü və inkişaf platforması.",
  },
  en: {
    title: "Yolutap — Career Navigation Platform",
    description:
      "Yolutap — a career-discovery and personal-development platform for children and young people aged 10–22.",
  },
};

/** title, description, og:* и twitter:* одним набором — чтобы ни один не остался от чужого языка. */
/**
 * Своя картинка превью 1200×630 (public/og/*.jpg) и большая карточка.
 * Один способ на весь сайт: подбор (abroad-start-*), репетиторы
 * (tutors-join-*). Без своей картинки страница наследует фото из __root и
 * маленькую карточку summary. url — абсолютный: мессенджеры относительный
 * адрес не разрешают. alt — заголовок карточки на языке страницы. type —
 * image/png у картинок, нарисованных на лету (/api/og/*).
 */
export function ogImageMeta(url: string, alt?: string, type = "image/jpeg") {
  return [
    { property: "og:image", content: url },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:type", content: type },
    ...(alt ? [{ property: "og:image:alt", content: alt }] : []),
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:image", content: url },
    ...(alt ? [{ name: "twitter:image:alt", content: alt }] : []),
  ];
}

export function socialMeta(m: { title: string; description: string; ogDescription?: string }) {
  const og = m.ogDescription ?? m.description;
  return [
    { title: m.title },
    { name: "description", content: m.description },
    { property: "og:title", content: m.title },
    { property: "og:description", content: og },
    { name: "twitter:title", content: m.title },
    { name: "twitter:description", content: og },
  ];
}
